// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.table-picking {\n  width: 100%;\n}\n.table-picking tbody td,\n.table-picking thead th {\n  text-align: left;\n  padding: 5px;\n}\n.table-picking thead th {\n  border-bottom: 1px solid #ccc;\n  border-top: 1px solid #ccc;\n}\n.table-picking input {\n  width: 50px;\n  text-align: right;\n  padding: 5px;\n  border: 1px solid #ccc;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
